// defined in the annotation tool:
// https://github.com/clio/clio-draft-annotations/blob/master/annotation_tool/pdfparser/tagged_pdf_parser.py#L42
const ANNOTATION_TOOL_CANVAS_WIDTH = 816;

const US_LETTER_PORTRAIT_WIDTH = 612;

export const getPdfScalingFactor = (webviewerInstance: any): number => {
  const { width, height } =
    webviewerInstance.docViewer?.getDocument()?.getPageInfo(1) ?? {};

  let ratio;
  if (!width || !height) {
    ratio = ANNOTATION_TOOL_CANVAS_WIDTH / US_LETTER_PORTRAIT_WIDTH;
  } else {
    ratio = ANNOTATION_TOOL_CANVAS_WIDTH / width;
  }

  return Math.round(ratio * 1000) / 1000;
};
